var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelOrderTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7143 11.2858H24.1429L26.7143 14.1786V19.0001H20.7143V11.2858Z",
    stroke: "#5D6569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99997 24.7587C11.1834 24.7587 12.1428 23.7993 12.1428 22.6159C12.1428 21.4324 11.1834 20.473 9.99997 20.473C8.81651 20.473 7.85712 21.4324 7.85712 22.6159C7.85712 23.7993 8.81651 24.7587 9.99997 24.7587Z",
    stroke: "#5D6569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8572 24.7587C24.0406 24.7587 25 23.7993 25 22.6159C25 21.4324 24.0406 20.473 22.8572 20.473C21.6737 20.473 20.7143 21.4324 20.7143 22.6159C20.7143 23.7993 21.6737 24.7587 22.8572 24.7587Z",
    stroke: "#5D6569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53558 1.85718C3.50402 1.85718 1.85712 3.50408 1.85712 5.53564C1.85712 7.5672 3.50402 9.2141 5.53558 9.2141C7.56714 9.2141 9.21404 7.5672 9.21404 5.53564C9.21404 3.50408 7.56714 1.85718 5.53558 1.85718ZM0.357117 5.53564C0.357117 2.67565 2.67559 0.357178 5.53558 0.357178C8.39557 0.357178 10.714 2.67565 10.714 5.53564C10.714 8.39563 8.39557 10.7141 5.53558 10.7141C2.67559 10.7141 0.357117 8.39563 0.357117 5.53564ZM7.92475 4.20711L7.39442 4.73744L6.59621 5.53565L7.39442 6.33386L7.92475 6.86419L6.86409 7.92485L6.33376 7.39452L5.53555 6.59631L4.73734 7.39452L4.20701 7.92485L3.14635 6.86419L3.67668 6.33386L4.47489 5.53565L3.67668 4.73744L3.14635 4.20711L4.20701 3.14645L4.73734 3.67678L5.53555 4.47499L6.33376 3.67678L6.86409 3.14645L7.92475 4.20711Z",
    fill: "#B84232"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5664 7.60022C10.675 7.21147 10.7331 6.80163 10.7331 6.37822C10.7331 6.28487 10.7303 6.19217 10.7247 6.10022H20.5697C20.9839 6.10022 21.3197 6.43601 21.3197 6.85022V18.956C21.3197 19.3702 20.9839 19.706 20.5697 19.706H6.6015C6.18729 19.706 5.8515 19.3702 5.8515 18.956V10.8955C5.96731 10.9044 6.08434 10.9089 6.20242 10.9089C6.59945 10.9089 6.98454 10.8579 7.3515 10.7619V18.206H19.8197V7.60022H10.5664Z",
    fill: "#5D6569"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelOrderTruck);
export default __webpack_public_path__ + "static/media/cancelOrderTruck.804631e38c79d30699c0eb204efecf89.svg";
export { ForwardRef as ReactComponent };